Ext.define('SA.model.LocationValue', {
    statics: {
        for(value) {
            var modelFactory = SA.model.LocationFactory,
                types = [
                    SA.model.LocationValue.Null,
                    SA.model.LocationValue.String,
                    SA.model.LocationValue.Item,
                    SA.model.LocationValue.Normalized,
                    SA.model.LocationValue.SeriesCacheConformant,
                    SA.model.LocationValue.CustomCacheConformant,
                    SA.model.LocationValue.EphemeralRadius
                ],
                type = types.find(type => type.isConformantValue(value));

            return Reflect.construct(type, [{value, modelFactory}]);
        },

        isConformantStringValue(value) {
            return SA.model.LocationValue.String.isConformantValue(value);
        },

        isEphemeralRadiusStringId(value) {
            return SA.model.LocationValue.EphemeralRadius.isStringId(value);
        }
    },

    constructor({value, modelFactory}) {
        this.value = value;
        this.modelFactory = modelFactory;
    },

    toItem() {
        return this.toModel().toItem();
    },

    toModel() {
        return this.modelFactory.create(this.getId());
    },

    toNormalized() {
        return this.toModel().toNormalized();
    },

    toString() {
        return this.toModel().getStringId();
    }
});